import Header from "./Header";
import Footer from "./Footer";

const NonAuth = ({ children }) => {
    return (
        <>
            <Header />
            {
                children
            }
            <Footer />
        </>
    )
};

export default NonAuth